<template>
  <div class="layout-footer text-center py-3 text-500">
    <!-- <img alt="Logo" :src="footerImage()" height="30" class="mr-2" /> -->
    <p>&copy; 2025 IDS Chatbot. Tous droits réservés. </p>
    <!-- <p>
      <a href="/guide-utilisateur" target="_blank">Guide utilisateur</a> |
      <a href="mailto:support@innovdevstack.com">Support</a>
    </p> -->
  </div>
</template>


<script>
	export default {
		name: "AppFooter",
		methods: {
			footerImage() {
				return this.$appState.darkTheme ? 'images/ids_logo.svg' : 'images/ids_logo.svg';
			}
		},
		computed: {
			darkTheme() {
				return this.$appState.darkTheme;
			}
		}
	}
</script>